import { useField } from "formik";
import React from "react";
import { useSelector } from "react-redux";

import { useGenresList } from "../../helpers/optionSets";
import { useStrings } from "../../localization/localizationHelpers";
import { getIsSavingForm } from "../../redux/selectors";
import { DropdownField } from "../DropdownField";
import { TextField } from "../TextField";

// This is the incoming value for the "Other" genre option coming from CRM
export const OtherGenreValue = 100000009;

export const GenreDropdown = () => {
  const [genreField] = useField({ name: "genre" });
  const [genre, otherGenre] = useStrings("genre", "otherGenre");
  const genresList = useGenresList();
  const isSavingFormToCrm = useSelector(getIsSavingForm);
  return (
    <>
      <DropdownField
        name="genre"
        values={genresList}
        title={genre}
        type="number"
        isSaving={isSavingFormToCrm}
      />
      {genreField.value === OtherGenreValue && (
        <TextField
          name={"otherGenre"}
          title={otherGenre}
          isSaving={isSavingFormToCrm}
          isRequiredField={true}
        />
      )}
    </>
  );
};
